import {
  DEATH_WAVE,
  GOLDEN_TOWER,
  BLACK_HOLE,
  SPOTLIGHT,
  SMART_MISSILES,
  CHRONO_FIELD,
  POISON_SWAMP,
  INNER_LAND_MINES,
  CHAIN_LIGHTNING,
} from 'utils/constants';
import BlackHole from './BlackHole';
import ChainLightning from './ChainLightning';
import ChronoField from './ChronoField';
import DeathWave from './DeathWave';
import GoldenTower from './GoldenTower';
import InnerLandMines from './InnerLandMines';
import PoisonSwamp from './PoisonSwamp';
import SmartMissiles from './SmartMissiles';
import SpotLight from './Spotlight';
import './Results.scss';

const Results = ({ unlocked, choices, currentCount }) => {
  const params = {
    unlocked,
    currentCount,
    choices,
    showAll: false,
  };
  if (choices[CHAIN_LIGHTNING]) return <ChainLightning {...params} />;
  if (choices[SPOTLIGHT]) return <SpotLight {...params} />;
  if (choices[BLACK_HOLE]) return <BlackHole {...params} />;
  if (choices[CHRONO_FIELD]) return <ChronoField {...params} />;
  if (choices[INNER_LAND_MINES]) return <InnerLandMines {...params} />;
  if (choices[SMART_MISSILES]) return <SmartMissiles {...params} />;
  if (choices[POISON_SWAMP]) return <PoisonSwamp {...params} />;
  if (choices[GOLDEN_TOWER]) return <GoldenTower {...params} />;
  if (choices[DEATH_WAVE]) return <DeathWave {...params} />;

  return null;
};

export default Results;
